module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"see_all":"모든 리뷰보기"}}')
  delete Component.options._Ctor
}
